<template>
  <div class="row">
    <div class="col-12">
      <code v-if="debug">
        {{ data }}
        <hr />
        {{ model }}
      </code>

      <div>
        <b-form-group
          label="Airline Id"
          :disabled="data && data.MenuAirlineId"
          hidden
        >
          <b-form-input
            v-model="model.MenuAirlineId"
            class="col-2"
          ></b-form-input>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Group Name" :disabled="data && data.MenuAirlineId">
          <b-form-input
            v-model="model.AirlineName"
            class="col-2"
          ></b-form-input>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Group Code" :disabled="data && data.MenuAirlineId">
          <b-form-input
            v-model="model.AirlineIcaoCode"
            :state="airlineCodeValid"
            :maxlength="3"
            class="col-2 uc"
          ></b-form-input>
        </b-form-group>
      </div>

      <div>
        <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0"
          >Logo Preview</legend
        >
        <div
          v-if="data && !model.AirlineLogo.name"
          class="airline-logo-preview"
        >
          <img :src="model.AirlineLogo" />
        </div>
        <div
          v-if="model.AirlineLogo && model.AirlineLogo.name"
          class="airline-logo-preview"
        >
          <img :src="getTempLogo()" />
        </div>
        <div v-if="model.AirlineLogo && model.AirlineLogo.name" class="mt-3"
          >Selected file:
          <b>{{
            model.AirlineLogo
              ? `${model.AirlineLogo.name} (${model.AirlineLogo.size}kb)`
              : ''
          }}</b></div
        >
      </div>
      <div class="file-drop-area mt-2">
        <span class="file-msg"
          >Drag and drop the airline logo here or use the 'choose file' button
          below.</span
        >
        <b-form-file
          ref="file_upload"
          v-model="model.AirlineLogo"
          :state="Boolean(file)"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
          class="file-input"
        ></b-form-file>
      </div>
      <b-form-file v-model="model.AirlineLogo" class="mt-2" plain></b-form-file>
    </div>
    <hr />
    <div class="col-12 bt-1">
      <b-button variant="success" class="mr-1" @click="save">Save</b-button>
      <b-button variant="success" @click="saveAndClose"
        >Save &amp; Close</b-button
      >
      <b-button variant="secondary" class="ml-1" @click="cancel"
        >Cancel</b-button
      >
    </div>
  </div>
</template>

<script>
import NotificationMixin from '@mixins/notificationMixin.js'
import CancelMixin from '@mixins/cancel.js'


import axios from 'axios'

export default {
  mixins: [NotificationMixin, CancelMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    contentType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      debug: false,
      boolsSwitches: {},
      model: {
        MenuAirlineId: null,
        AirlineName: null,
        AirlineIcaoCode: null,
        AirlineLogo: null,
      },
    }
  },
  computed: {
    airlineCodeValid() {
      return (
        this.model.AirlineIcaoCode &&
        this.model.AirlineIcaoCode.length > 1 &&
        this.model.AirlineIcaoCode.length <= 3
      )
    },
    handlers() {
      return this.$store.getters['Handlers/list']
    },
    locationAreas() {
      return this.$store.getters['LocationAreas/list']
    },
    locationAreasLabel() {
      return this.locationAreas.find(
        (e) => e.LocationAreaId === this.model.LocationAreaId
      )
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(data) {
        if (data) this.mapData(data)
      },
    },
    boolsSwitches: {
      deep: true,
      handler(bools) {
        // The server model uses T/F rather than bools!
        this.model.CheckInEnabled = bools.CheckInEnabled ? 'T' : 'F'
        this.model.BagTagPrintingEnabled = bools.BagTagPrintingEnabled
          ? 'T'
          : 'F'
      },
    },
  },

  beforeCreate() {
    // Get dependency data
    const depData = ['LocationAreas', 'Handlers']
    depData.forEach((key) => {
      this.$store.dispatch(`${key}/all`)
    })
  },
  methods: {
    fileUploadClick() {
      this.$refs.file_upload.click()
    },
    getTempLogo() {
      if (!this.model.AirlineLogo) {
        return null
      }
      if (this.model.AirlineLogo && this.model.AirlineLogo.name) {
        return URL.createObjectURL(this.model.AirlineLogo)
      }
    },
    mapData(dataIn) {
      //   Take the server data and apply it to our model
      this.model.MenuAirlineId = dataIn.MenuAirlineId
      this.model.AirlineName = dataIn.AirlineName
      this.model.AirlineIcaoCode = dataIn.AirlineIcaoCode
      this.model.AirlineLogo = dataIn.AirlineLogo
    },
    async save() {
      if (this.saveDisabled) {
        return
      }
      let id, type
      if (this.data) {
        id = this.data[this.contentType.idKey]
        type = 'patch'
      } else {
        id = 0
        type = 'post'
      }
      try {
        if (type === 'post') {
          this.postOverride()
        } else {
          console.log(id)
          this.patchOverride()
        }
        this.showNotification('Saved successfully', 'success')
      } catch (error) {
        this.showNotification(error, 'error')

        throw new Error(error)
      }
    },
    async saveAndClose() {
      if (this.saveDisabled) {
        return
      }
      try {
        await this.save()
      } catch (error) {
        window.console.log(error)
        return
      }
      this.$router.push(`/${this.contentType.name}/list`)
    },
    postOverride() {
      const config = { headers: { 'Content-Type': 'multipart/form-data' } }
      const data = new FormData()
      data.append('sourceFileName', this.model.AirlineLogo)

      axios
        .post(
          `${this.$config.apiBaseUrl}kioskManage/menuairline/add/airline/${
            this.model.AirlineName
          }/code/${this.model.AirlineIcaoCode.toUpperCase()}/filename/${
            this.model.AirlineLogo.name
          }/`,
          data,
          config
        )
        .then((response) => {
          this.getData()
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => (this.isLoading = false))
    },
    patchOverride() {
      const config = { headers: { 'Content-Type': 'multipart/form-data' } }
      const data = new FormData()
      data.append('sourceFileName', this.model.AirlineLogo)

      axios
        .patch(
          `${
            this.$config.apiBaseUrl
          }kioskManage/menuairline/update/airline/${
            this.model.AirlineName
          }/code/${this.model.AirlineIcaoCode.toUpperCase()}/filename/${
            this.model.AirlineLogo.name
          }/`,
          data,
          config
        )
        .then((response) => {
          this.getData()
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => (this.isLoading = false))
    },
  },
}
</script>

<style lang="scss" scoped>
.airline-logo-preview {
  width: 400px;
  background: #1a1e23;
  padding: 2rem;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.file-drop-area {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 60vw;
  max-width: 100%;
  padding: 50px;
  border: 2px dashed rgb(222 226 230);
  border-radius: 4px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  background: #fcfcfd;
  transition: 0.2s;
  &.is-active {
    background-color: rgba(255, 255, 255, 0.05);
  }
}

.fake-btn {
  flex-shrink: 0;
  background-color: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(154, 154, 154, 0.4);
  border-radius: 3px;
  padding: 8px 15px;
  margin-right: 10px;
  font-size: 12px;
  text-transform: uppercase;
}

.file-msg {
  font-size: small;
  font-weight: 300;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-input {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
  opacity: 0;
  &:focus {
    outline: none;
  }
}

.airline-logo-preview img {
  max-width: 100%;
}
</style>
